import {
  CreateGUFHeightTask,
  EditGUFHeightTask,
  QualityRegimeOptions,
} from "@nens/brostar/uploadapi-client";

import { BrostarUiSchema } from "@/libs/brostar-form";

import { createGufUiSchemaLibrary } from "./guf-ui-schema-library";

export function useGufHeightUiSchema(
  qualityRegimeValue: QualityRegimeOptions | undefined
): BrostarUiSchema<CreateGUFHeightTask | EditGUFHeightTask> {
  const {
    projectNumber,
    qualityRegime,
    deliveryAccountableParty,
    broId,
    correctionReason,
    realisedWellId,
    height,
    wellDepth,
    startValidity,
    realisedScreenId,
    topScreenDepth,
  } = createGufUiSchemaLibrary(qualityRegimeValue);

  const uiSchema: BrostarUiSchema<CreateGUFHeightTask | EditGUFHeightTask> = {
    "ui:order": ["metadata", "sourcedocumentData"],
    metadata: {
      "ui:title": "Metadata",
      projectNumber,
      qualityRegime,
      deliveryAccountableParty,
      broId,
      correctionReason,
    },
    sourcedocumentData: {
      "ui:title": "Brondocumentgegevens",
      "ui:order": ["realisedWellId", "height", "wellDepth", "startValidity", "realisedScreens"],
      realisedWellId,
      height,
      wellDepth,
      startValidity,
      realisedScreens: {
        "ui:options": { labelField: "realisedScreenId" },
        items: {
          "ui:order": ["realisedScreenId", "topScreenDepth"],
          realisedScreenId,
          topScreenDepth,
        },
      },
    },
  };

  return uiSchema;
}
